import * as React from "react";
import styled, { css } from "styled-components";

import { Modal } from "src/library/components/Modal";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { Input } from "src/library/components/Forms";

interface IProps {
  show: boolean;
  onConfirm: (listName: string) => void;
  handleDismiss: () => void;
  terminology: ITerminology;
}

const ListFromOrderModal: React.ReactFCWithChildren<IProps> = ({
  show, onConfirm, handleDismiss, terminology
}) => {
  const [ listName, setListName ] = React.useState<string>();
  const [ validation, setValidation ] = React.useState<string>();

  return (
    <Modal
      small
      type="confirm"
      show={show}
      title={`Create ${terminology.list.singular.text} from ${terminology.order.singular.text}`}
      body=""
      content={(
        <div>
          <div>
            <Input
              name="list-name"
              label={`${terminology.list.singular.text} name`}
              as="input"
              inputType="text"
              handleChange={e => setListName(e.target.value)}
              value={listName}
            />
          </div>

          <ValidationError>
            {validation}
          </ValidationError>
        </div>
      )}
      actions={[
        {
          name: "Cancel",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: `Create ${terminology.list.singular.text}`,
          action: () => {
            if (listName) {
              onConfirm(listName);
              handleDismiss();
            } else {
              setValidation(`${terminology.list.singular.text} name is required`);
            }
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
    />
  );
};

const ValidationError = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.error};
    font-weight: ${theme.fonts.weights.bold};
    font-size: ${theme.fonts.sizes.p};
  `}
`;

export default ListFromOrderModal;
